
import Vue from "vue";
import { AllContactsService } from "@/services/all-contacts-service";
import { Contact } from "@/models/base";
import { HumanFilter } from "@/utils/human-filter";
import { UserConfigService} from "@/services";

export default Vue.extend({
	data() {
		return {
			enterPressed: false,
			realTimeText: "",
			foundContacts: [] as Contact[],
			input: "",
			wait: UserConfigService.getSaleSettings().WaitForEnterOnContactSearch,
		};
	},
	props: {
		value: Object as () => Contact,
		groupId: {
			type: [Number, Array as () => number[]],
		},
		fancy: Boolean,
		label: [String, Object],
		clearOnEnter: Boolean,
		disabled: Boolean,
		icon: String,
		iconLeft: String,
		autoFocus: Boolean,
		iconTooltip: [String, Object],
		iconLeftTooltip: [String, Object],
	},
	computed: {
		computedGroupIds(): number[] {
			if (typeof (this.groupId) == "object") {
				return this.groupId;
			}
			return [this.groupId];
		}
	},
	watch: {
		async input(input: string) {
			this.realTimeText = input;
			if (input.match(/^\s*$/)) {
				this.foundContacts = [];
				return;
			}
			if(!this.wait) {
				this.foundContacts = await AllContactsService.searchByName(this.input, false, this.getGroupExtraFilters());
			}
		},
		value: {
			immediate: true,
			handler(contact?: Contact) {
				if (this.value) {
					this.input = this.value.getDisplayName();
				} else {
					this.input = "";
				}
			}
		}
	},
	methods: {
		onRealTimeValue(text:string){
			this.realTimeText = text;
		},
		keyup(event: KeyboardEvent) {
			if(event.key == "Enter"){
				this.enterPressed = true;
				this.searchOnEnter();
				return;
			}
			if(this.wait && event.key != "ArrowDown" && event.key != "ArrowUp"){
				this.foundContacts = [];
			}
			//this.$emit("keyup", event);
		},
		async searchOnEnter(){
			let foundContacts = [] as any;
			this.foundContacts = [];
			if (this.realTimeText.match(/^\s*$/)) {
				this.foundContacts = [];
				return;
			}
			if (this.value && this.value.ComputedFriendlyID == this.realTimeText) {
				this.$emit("blur");
				return;
			}
			foundContacts = await AllContactsService.searchByName(this.realTimeText, false, this.getGroupExtraFilters());
			if(foundContacts.length == 1){
				this.selectContact(foundContacts[0]);
			}else{
				this.foundContacts = foundContacts;
			}
			this.enterPressed = false;
		},
		getGroupExtraFilters():HumanFilter[]{
			if (this.groupId == null) {
				return [];
			}
			if (typeof(this.groupId) == "number"){
				return [
					new HumanFilter({
						Field: "this.GroupID",
						Operator: "=",
						Values: [`${this.groupId}`]
					}),
				];
			}
			return [
				new HumanFilter({
					Field: "this.GroupID",
					Operator: "in",
					Values: this.groupId.map(g=>`${g}`)
				})
			];
		},
		onBlur() {
			this.foundContacts = [];
			if (this.value) {
				if (this.value.MainAddress) {
					this.input = this.value.getDisplayName();
				}
			}else{
				this.input = "";
			}
			this.$emit("blur");
		},
		onFocus() {
			this.input = "";
		},
		selectContact(contact: Contact) {

			this.$emit("input", contact);
			if (this.clearOnEnter) {
				this.input = "";
			}
			this.blur();
		},
		focus() {
			(this.$refs.input as any).focus();
		},
		blur() {
			(this.$refs.input as any).blur();
		},
		searchContacts() {
			if (this.$listeners["icon-click"]){
				return this.$emit("icon-click");
			}
			console.trace("Right icon clicked");
			this.$emit("searchContacts");
		},
		iconLeftClick(){
			this.$emit("icon-left-click");
		}
	},
	mounted() {
		if (this.autoFocus) {
			this.focus();
		}
	},
	i18nEx: {
		componentPrefix: "components.contact-search"
	}
});
